import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../../Components/LoadingSpinner';
import AddEditDeliveryAddress from '../AddressesPanel/AddEditDeliveryAddress';

const MainDeliveryAddressCard = ({ isLoading, addresses }) => {
    const { t } = useTranslation()
    const [handlingAddress, setHandlingAddress] = useState({ name: '', street: '', zipCode: '', city: '', email: '', phone: '', recNo: 0, isExpAddress: false, expirationDate: '' })
    const [editingAddress, setEditingAddress] = useState({ name: '', street: '', zipCode: '', city: '', email: '', phone: '', recNo: 0, isExpAddress: false, expirationDate: '' })
    const [isChangeAddressVisible, setisChangeAddressVisible] = useState(false);

    useEffect(() => {
        for (const address of addresses) {
            if (address.mainDeliveryAddress) {
                setHandlingAddress({ name: address.fullName, street: address.street, zipCode: address.zipCode, city: address.city, email: address.email.trim(), phone: address.phoneNumber, recNo: address.recNo, isExpAddress: address.effectiveDate ? true : false, expirationDate: address.effectiveDate ? address.effectiveDate : '' })
            }
        }
    }, [addresses])

    const handleChangeAddressButtonClick = () => {
        setEditingAddress({ name: handlingAddress.name, street: handlingAddress.street, zipCode: handlingAddress.zipCode, city: handlingAddress.city, email: handlingAddress.email.trim(), phone: handlingAddress.phone, recNo: handlingAddress.recNo, isExpAddress: handlingAddress.effectiveDate ? true : false, expirationDate: handlingAddress.effectiveDate ? handlingAddress.effectiveDate : '' })
        setisChangeAddressVisible(true);
    }
    return (
        <div>
            <div className='row justify-content-center'>
                <div className='justify-content-center mt-2'>
                    <div>
                        <AddEditDeliveryAddress handlingAddress={editingAddress} setHandlingAddress={setEditingAddress} isChangeAddressVisible={isChangeAddressVisible} setisChangeAddressVisible={setisChangeAddressVisible} fromMainDeliveryCard={true} />
                        <div className='panel-header-title'>Główny adres dostawy</div>
                        {isLoading && <LoadingSpinner />}
                        {!isLoading && <div className='col-auto ms-1'>
                            {handlingAddress.name} <br />
                            {handlingAddress.street}<br />
                            {`${handlingAddress.zipCode} ${handlingAddress.city}`} <br />
                            {handlingAddress.phone && handlingAddress.phone.trim() && <div>{t("phone") + ': ' + handlingAddress.phone}<br /></div>}
                            {handlingAddress.email && handlingAddress.email.trim() && 'E-mail: ' + handlingAddress.email}
                        </div>}
                        <button className='btn-app-secondary mt-3' onClick={handleChangeAddressButtonClick}>
                            Zmień dane
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};



export default MainDeliveryAddressCard;